// removed by extract-text-webpack-plugin
module.exports = {"container":"G1c0397"};